import React from 'react';
import { useMappingState } from '../tableMappingProvider';
import JsonDataView from './jsonDataView';
import LineNumbers from './lineNumbers';
import { JSONHeader, JsonViewMain, JsonViewWrapper } from './styles';

const JsonView = () => {
  const { jsonData } = useMappingState();
  return (
    <div style={{ flex: 1, maxWidth: '50%' }}>
      <JSONHeader alignItems="center">JSON:</JSONHeader>
      <JsonViewWrapper>
        <JsonViewMain>
          <LineNumbers jsonData={jsonData || []} />
          <JsonDataView jsonData={jsonData || []} />
        </JsonViewMain>
      </JsonViewWrapper>
    </div>
  );
};

export default JsonView;
